import { useState } from "react";
import { useValidator } from "../../common/hooks/validation";
import { useTranslation } from "../../localization/useTranslation";
import { IAddTaskForm, TaskCreateModel } from "./CreateTaskPane.types";
import { post } from "../../common/api/apiShared";
import { isNullOrWhitespace } from "../../common/stringOperations";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { useResponsibleQuery } from "../../user/hooks/useResponsibleQuery";

export default function useCreateTaskPane(props: IAddTaskForm) {
    const { translateString } = useTranslation();

    const [saveModel, setSaveModel] = useState<TaskCreateModel>({
        name: isNullOrWhitespace(props.prefixName ?? null) ? "" : props.prefixName!,
        deadline: convertDate(new Date()),
        responsible: "",
        relation: props.relationInformation
            ? {
                  toEntityType: props.relationInformation?.toEntityType,
                  fromEntityId: props.relationInformation?.fromEntityId,
                  fromEntityType: props.relationInformation?.fromEntityType,
              }
            : undefined,
    });

    let responsibleQuery = useResponsibleQuery();

    const validation = useValidator<TaskCreateModel>(
        (validators) => ({
            name: validators.validateNotEmpty((item) => item.name, translateString("name")),
            responsible: validators.validateNotEmpty((item) => item.responsible, "", undefined, translateString("annualWheelDataTaskResponsibleError")),
            deadline: validators.validateNotEmpty((item) => item.deadline, translateString("deadline")),
        }),
        []
    );

    validation.check(saveModel);

    const onModelChange = (updateFunc: (model: TaskCreateModel) => void) => {
        let tempSaveModel = { ...saveModel! };

        updateFunc(tempSaveModel);
        setSaveModel(tempSaveModel);
    };

    const saveMutation = useDotLegalMutation(addTaskAPI, {
        onSuccess: (response: any) => {
            if (response.success()) {
                props.onTaskCreated(response.value().id);
            }
        },
    });

    const onSave = async () => {
        if (validation.anyHasErrors) {
            validation.setShowErrors(true);
            return;
        }

        await saveMutation.mutateAsync();
    };

    function addTaskAPI() {
        return post<string>("/task", saveModel);
    }

    function convertDate(date: Date) {
        return new Date(date!.getFullYear()!, date.getMonth(), date.getDate());
    }

    return {
        saveModel,
        setSaveModel,
        validation,
        onModelChange,
        onSave,
        responsibleData: responsibleQuery.userData?.filter((x) => x.active),
        responsibleIsLoading: responsibleQuery.isLoading,
        convertDate,
        isSaving: saveMutation.isLoading,
    };
}
